import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PcTabsPage } from '../pc-tabs/pc-tabs';
import { AlertController } from 'ionic-angular';
import { PartesService} from '../../services/partes.services';

@IonicPage()
@Component({
  selector: 'page-parte-detalle',
  templateUrl: 'parte-detalle.html',
})
export class ParteDetallePage {
  item = {id : null,disabled : false, Orden : null,Fecha : null, Poblacion : null, Unidades : 0, Observaciones : null, lineas : [], personal : []};
  variedades = [];
  personal = [];
  vale = {idParte: null, Vale:null,Variedad: null, Unidades: null};
  persona = {id: null, Nombre:null, Encargado : null, Plus : null};

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public partesService : PartesService){
    //Cargo las Variedades
    partesService.getVariedades()
      .subscribe(variedades => {
        this.variedades = variedades;
    });

    //Cargo el Personal
    this.personal = partesService.personal;
     
    //Si el item no es vacio, cargo el item que me pasan como parametro para edición.
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }else{ 
      this.item.id = partesService.getIdParte() + 1;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ParteDetallePage');
  }

  volver(){
    this.navCtrl.setRoot(PcTabsPage);
  }

  //Devuelve el numero de Unidades de las lineas de un Parte
  public countUnidades(){
    let Unidades = parseInt("0");
    for (let i = 0; i < this.item.lineas.length; i++){
      Unidades = Unidades + parseInt(this.item.lineas[i].Unidades);
    }
    return Unidades;
  }  

  //Añadir Parte
  addParte(){
    if(this.item.lineas.length <= 0){
      alert("Debes de asignar al menos un vale al Parte de Trabajo.");
    }else if(this.item.personal.length <= 0){
      alert("Debes de asignar al menos una persona al Parte de Trabajo.");
    }
    else{
      this.item.Unidades = this.countUnidades();
      this.item.Orden = 100000000 - this.item.id;
      this.partesService.editParte(this.item);
      this.navCtrl.pop();
    }
  } 

  //Borrar Vale
  deleteVale(linea){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar este Vale?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
            for (let j= 0; j < this.item.lineas.length; j++){
              if(this.item.lineas[j] == linea){
                this.item.lineas.splice(j, 1);
              }
            }
           }
        }
      ]
    });
    alert.present();
  }

  //Borrar PArte
  deleteParte(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar este Parte?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteParte(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  }  

  //Añadir un Vale a Parte Recolección
  addVale(){
    this.vale.idParte = this.item.id;
    this.vale.Unidades = "0";
    this.vale.Vale = "";
    this.vale.Variedad = "";
    this.item.lineas.push(this.vale);
    this.vale = {idParte: null,Vale:null,Variedad: null,Unidades: null};
  }

  //Añadir el Personal a Parte Recolección
  addPersonal(){
    for (let i= 0; i < this.personal.length; i++){
      if (this.personal[i].Activo == true){
        this.persona.id = this.personal[i].id;
        this.persona.Nombre = this.personal[i].Nombre;
        this.persona.Encargado = this.personal[i].Encargado;
        this.persona.Plus = ""; 
        this.item.personal.push(this.persona);
        this.persona = {id: null,Nombre:null, Encargado : null, Plus : null};
      }
    }
  }

  //Borrar el personal asignado al parte
  deletePersonal(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar al personal de este Parte?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.item.personal = [];
           }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/parte-detalle/parte-detalle.ts